/**
 * Thin async wrapper around the Rapier WASM physics module.
 *
 * The `@dimforge/rapier3d-compat` package inlines the wasm as base64 and
 * requires a one-time async `init()` before any API can be used. We await it
 * once here and re-export the initialized module so callers never have to
 * think about the lifecycle.
 *
 * The sim/renderer split: this file lives in `src/sim/` and must NEVER import
 * three.js. It is pure physics + TS, runnable headless in Node.
 */

import RAPIER from "@dimforge/rapier3d-compat";

let initialized = false;

/**
 * Initialize the Rapier WASM module. Safe to call multiple times; the wasm
 * init runs exactly once.
 *
 * @returns the initialized RAPIER namespace (default export).
 */
export async function initPhysics(): Promise<typeof RAPIER> {
  if (!initialized) {
    await RAPIER.init();
    initialized = true;
  }
  return RAPIER;
}

export { RAPIER };
